import {Record, List} from 'immutable';
import {scorecardTypes} from 'records/Scorecard';
import CardReasonSchemeEntry from './CardReasonSchemeEntry';

export default class CardReasonScheme extends Record({
  id: null,
  name: null,
  entries: List(),
  optional: false,
  scoringScheme: null,
}) {
  constructor(object = {}) {
    // we can get not every point from the backend,
    // so here we need to add the missing ones
    const neededEntries =
      object && object.scoringScheme
        ? scorecardTypes[object.scoringScheme].answers.map(e => e.value)
        : [];

    const entries = object && object.entries ? object.entries : [];

    const useEntries = neededEntries.map(neededPoint => {
      const entry = entries.find(entry => entry.point === neededPoint);

      if (entry !== undefined) {
        return entry;
      } else {
        return {point: neededPoint, reasons: List()};
      }
    });

    super(
      Object.assign({}, object, {
        entries: List((useEntries || []).map(entry => new CardReasonSchemeEntry(entry))),
      })
    );
  }
}
